import React from 'react';
import logo from '../Assets/new logo.png'; 
import phone from '../../assets/phone.png';
import mail from '../../assets/mail.png';
import location from '../../assets/location.png';

const Footer = () => {
  return (
    <footer className="bg-[#551E19] text-[#f5deb3] pt-10 pb-6 px-6 md:px-[10%]">
      <div className="flex flex-col md:flex-row items-center md:items-start md:justify-between justify-center md:space-y-0 space-y-8 md:gap-20">
        <div className="w-full max-w-[350px] flex flex-col items-center md:items-start text-center md:text-left">
          <a className="mb-2" href='./'>
            <img
              src={logo}
              alt="Poo Poo Shop Logo"
              className="w-64 mx-auto md:mx-0"
            />
          </a>
          <div className="mb-5">
            <p className="font-bold font-oswald text-lg text-white">Your Pet Deserves the Best</p>
            <p className="mt-5 text-white font-light">
              Discover the finest accessories to keep your pets happy, healthy, and stylish.
            </p>
          </div>
          <div className="flex space-x-3 text-xl justify-center md:justify-start">
            <a href="#"><i className="fab fa-facebook"></i></a>
            <a href="#"><i className="fab fa-instagram"></i></a>
            <a href="#"><i className="fab fa-linkedin"></i></a>
            <a href="#"><i className="fab fa-whatsapp"></i></a>
          </div>
        </div>

        <div className="flex-1 max-w-[120px] text-center md:text-left">
          <h3 className="text-[#E6B17E] mb-4 font-semibold tracking-wide whitespace-nowrap">Quick Links</h3>
          <ul className="list-inside text-white">
            <li className="whitespace-nowrap"><a href="/" className="hover:text-[#E6B17E] text-sm tracking-wide">Home</a></li>
            <li className="whitespace-nowrap"><a href="/shop" className="hover:text-[#E6B17E] text-sm tracking-wide">Shop</a></li>
            <li className="whitespace-nowrap"><a href="/contact" className="hover:text-[#E6B17E] text-sm tracking-wide">Contact Us</a></li>
            <li className="whitespace-nowrap"><a href="/cart" className="hover:text-[#E6B17E] text-sm tracking-wide">Cart</a></li>
            <li className="whitespace-nowrap"><a href="/faqs" className="hover:text-[#E6B17E] text-sm tracking-wide">FAQs</a></li>
            <li className="whitespace-nowrap"><a href="/returns" className="hover:text-[#E6B17E] text-sm tracking-wide">Returns</a></li>
          </ul>
        </div>

        <div className="flex-1 max-w-[220px] text-center md:text-left md:tracking-wide">
          <h3 className="text-[#E6B17E] mb-4 font-semibold">Customer Care</h3>
          <ul className="text-white">
            <li className="mb-2 flex items-center justify-center md:justify-start">
              <img src={phone} className='w-8 h-8 xs:mr-2' />+94 768262939
            </li>
            <li className="mb-2 flex items-center">
              <img src={mail} className='w-8 h-8 xs:mr-2' /><i className="fas fa-envelope mr-2"></i>poopooShop13@gmail.com
            </li>
            <li className="flex items-center">
              <img src={location} className='w-8 h-8 xs:mr-2' /><i className="fas fa-map-marker-alt mr-2"></i>179/1B, Goluwawila, Ratnapura
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-8 pt-4 border-t border-[#ffffff] text-center text-white text-xs">
        <p>Copyright © 2024 Poo Poo Shop - All rights reserved</p>
        <p>Design & Development by Bison Corps</p>
      </div>
    </footer>
  );
};

export default Footer;
